export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-flex items-center gap-2 text-accent-600 text-sm font-medium mb-3">
              <i className="ri-information-line"></i>
              平台介绍
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
              关于爆瓜网
            </h2>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 md:p-12 border border-background-200/70">
            <div className="prose-custom space-y-5 text-foreground-700 leading-relaxed">
              <p className="text-base md:text-lg">
                爆瓜网成立于2023年，是国内领先的娱乐八卦资讯聚合平台。我们致力于为全网吃瓜群众提供最新、最快、最全的明星八卦、网红爆料与娱乐热点内容。从微博热搜到抖音热榜，从豆瓣小组到小红书热议，爆瓜网一站聚合多平台娱乐资讯，让你不再错过任何一个名场面。
              </p>
              <p>
                我们的编辑团队由资深娱乐记者、社交媒体分析师和内容策划专家组成，全天候监控全网热点动态。每一条爆料都经过多方信息源交叉验证，确保内容既有速度又有质量。我们坚持客观中立的立场，不站队、不引战，只做最专业的娱乐资讯搬运工和整理者。
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-8 pt-8 border-t border-background-200/50">
                <div className="text-center">
                  <div className="text-3xl font-heading font-bold text-primary-500 mb-2">2年+</div>
                  <p className="text-sm text-foreground-500">持续运营时间</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-heading font-bold text-accent-500 mb-2">5万+</div>
                  <p className="text-sm text-foreground-500">累计爆料内容</p>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-heading font-bold text-secondary-500 mb-2">99.7%</div>
                  <p className="text-sm text-foreground-500">内容准确率</p>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-background-200/50">
                <h3 className="font-heading font-bold text-foreground-900 text-lg mb-4">我们的理念</h3>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-sm"><strong>真实为本</strong>：每一条爆料都经过严格的事实核查，拒绝传播未经证实的谣言。</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-sm"><strong>速度为王</strong>：重大娱乐事件发生后，15分钟内完成初步报道，30分钟内发布详细内容。</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-sm"></i>
                    </span>
                    <span className="text-sm"><strong>中立客观</strong>：不站队、不引战，为吃瓜群众提供全面、均衡的事件视角。</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}